/**
 * 独自エラークラス
 */
export default class ApiError {
    constructor(json) {
        this.errorMessage = json['errorMessage'];
        this.errorCode = json['errorCode'];
        this.fieldErrorList = json['fieldErrorList'];
    }
}